import http from "@/utils/request";
import cdHttp from "@/utils/cdRequest";
import reqs from "@/utils/http";

export const adSignUp = (data) => {
  return http({
    url: process.env.VUE_APP_GATEWAY_URL + "/consumermanage/common/consumer",
    method: "POST",
    data,
  });
};
export const sendSms = (params) => {
  return cdHttp({
    url: "/app/send",
    method: "POST",
    params,
  });
};

// //发送短信
// export const sendMessege = (data) => {
//   return http({
//     url: "/api/public/v2/send",
//     method: "POST",
//     data,
//   });
// };

// //验证短信
// export const verifySnsCode = (data) => {
//   return http({
//     url: "/api/public/v2/verifySnsCode",
//     method: "POST",
//     data,
//   });
// };

//发送短信
export const sendMessege = (data) => {
  return reqs.request({
    url: "/consumer-admin-sms/consumermanage/sms/send",
    method: "POST",
    data,
  });
};

//验证短信
export const verifySnsCode = (data) => {
  return reqs.request({
    url: "/consumer-admin-sms/consumermanage/sms/verifySnsCode",
    method: "POST",
    data,
  });
};

//华为回调
export const huaweiConversion = (data) => {
  return http({
    url: "/ad/api/huawei/conversion",
    method: "POST",
    data,
  });
};

// 广告落地页列表查询
export const getLandingPageDetail = (id) => {
  return reqs.request({
    url:
      process.env.VUE_APP_GATEWAY_URL + "/consumermanage/essay/getById/" + id,
    method: "get",
  });
};

// 保存线索接收到新商机平台
export const receivejson = (data) => {
  return reqs.request({
    url: process.env.VUE_APP_GATEWAY_URL + "/opportunity/common/receivejson",
    method: "POST",
    data,
  });
};


// 获取会员小程序跳转链接
export const generatescheme = (data) => {
  return http({
    url:
      process.env.VUE_APP_GATEWAY_URL + "/user/app/wechatpublic/generatescheme",
    method: "POST",
    data,
  });
};

export const generateschemeV2 = (data) => {
  return http({
    url:
      process.env.VUE_APP_GATEWAY_URL + "/commonservice/wechatpublic/generateschemeV2",
    method: "POST",
    data,
  });
};


// 非会员预约金管家服务
export const saveNoMeberHKJServiceInfo = (data) => {
  return http({
    url:
      process.env.VUE_APP_GATEWAY_URL +
      "/member/memberservicerecord/saveNoMemberHKJServiceInfo",
    method: "POST",
    data,
  });
};

// 省市区
export const datadictionaryList = (params) => {
  return http({
    url: process.env.VUE_APP_GATEWAY_URL + "/dealermanage/datadictionary/list",
    method: "get",
    params,
  });
};

// 获取企业微信用户信息
export const qywechatloginApplets = (params) => {
  return http({
    url: process.env.VUE_APP_GATEWAY_URL + "/user/qywechatlogin/applets",
    method: "post",
    params,
    headers: {
      api_client_code: process.env.VUE_APP_QYWEIXIN_SYSTEM_CODE,
      api_version: "1.0.0",
      api_timestamp: Date.now(),
    },
  });
};

// 获取小程序跳转链接通用接口
export const wechatpublicGeneratescheme = (data) => {
  return http({
    url:
      process.env.VUE_APP_GATEWAY_URL + "/user/app/wechatpublic/generatescheme",
    method: "POST",
    data,
  });
};

//获取企业微信扫一扫权限
export const getTicketAndSignature = (params) => {
  return http({
    url: "/api/wxwork/getTicket",
    method: "get",
    params,
  });
};

//app下载
export let getEditionInfo = (params) => {
  return http({
    url: "/api/appEditionLog/getEditionInfo",
    method: "get",
    params,
  });
};
//双11招募令
export let saveRecruitForm = (data) => {
  return reqs.request({
    url: "/cdapi/commonSignupRecordApi/save",
    method: "post",
    data,
  });
};

//经纬度获取省市
export const appCityinfoGet = (params) => {
  return reqs.request({
    url: process.env.VUE_APP_GATEWAY_URL + "/commonservice/app/cityinfo/get",
    method: "get",
    params,
  });
};
